module.exports = __webpack_public_path__ + "static/img/ent-detail-19.2d4f37c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-19.jpg
// module id = /qV7
// module chunks = 52